import * as React from "react";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpSwitch } from "../../../gvc/testNewForm/CpSwitch";
import { CpDescription } from "../../../gvc/testNewForm/CpDescription";
import { CpArrayString } from "../../../gvc/testNewForm/CpArrayString";
import { CpArrayObject } from "../../../gvc/testNewForm/CpArrayObject";
import { CpArrayItemOutboundPort } from "./CpArrayItemOutboundPort";
import { OutboundPortInput } from "../../../../schema/types/workload/input";
import { v4 as uuidv4 } from "uuid";
import { OutboundFirewallRecommendationsHostnameList } from "./OutboundFirewallRecommendationsHostnameList";
import { OutboundFirewallRecommendationsPortAllowList } from "./OutboundFirewallRecommendationsPortAllowList";
import { CpLabelTooltip } from "../../../gvc/testNewForm/CpLabelTooltip";
import { CpTooltip } from "../../../gvc/testNewForm/CpTooltip";
import { CpLabelDirtyIndicator } from "../../../gvc/testNewForm/CpLabelDirtyIndicator";
import { Only } from "../only";

interface Props {}
export const ExternalOutbound: React.FC<Props> = ({}) => {
  const outboundPublic = useCpFormValue(`firewallConfig.external.outbound.public`);

  return (
    <>
      <CpFormItem>
        <CpLabelTooltip>
          <CpLabel name={`firewallConfig.external.outbound.public`}>
            Allow All Outbound Requests
            <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
              <CpLabelDirtyIndicator name={`firewallConfig.external.outbound.public`} />
            </Only>
          </CpLabel>
          <CpSwitch name={`firewallConfig.external.outbound.public`} />
          <CpTooltip tooltipProps={{ title: `Adds 0.0.0.0/0 to CIDR Allow List` }} />
        </CpLabelTooltip>
      </CpFormItem>
      {outboundPublic ? null : (
        <>
          <div style={{ maxWidth: 600 }}>
            <CpArrayString
              label={`CIDR Allow List`}
              name={`firewallConfig.external.outbound.allowCidr`}
              dirtyIndicator={{
                isEnabled: true,
                only: {
                  name: "meta.isCreate",
                  checkFn: (v) => v === false,
                },
              }}
            />
          </div>
          <div style={{ maxWidth: 600 }}>
            <div>Hostname Allow List</div>
            <OutboundFirewallRecommendationsHostnameList />
            <CpArrayString
              name={`firewallConfig.external.outbound.allowHostname`}
              dirtyIndicator={{
                isEnabled: true,
                only: {
                  name: "meta.isCreate",
                  checkFn: (v) => v === false,
                },
              }}
            />
          </div>
        </>
      )}
      <div style={{ maxWidth: 600 }}>
        <CpArrayString
          label={`CIDR Block List`}
          name={`firewallConfig.external.outbound.blockedCidr`}
          dirtyIndicator={{
            isEnabled: true,
            only: {
              name: "meta.isCreate",
              checkFn: (v) => v === false,
            },
          }}
        />
      </div>
      <div style={{ maxWidth: 600 }}>
        <div>Port Allow List</div>
        <OutboundFirewallRecommendationsPortAllowList />
        <CpArrayObject
          labels={["Protocol", "Number"]}
          factoryFn={() => {
            const newItem: OutboundPortInput = {
              id: uuidv4(),
              number: "",
              protocol: "tcp",
            };
            return newItem;
          }}
          name={`firewallConfig.external.outbound.allowPort`}
          dirtyIndicator={{
            isEnabled: true,
            only: {
              name: "meta.isCreate",
              checkFn: (v) => v === false,
            },
          }}
        >
          <CpArrayItemOutboundPort />
        </CpArrayObject>
      </div>
    </>
  );
};
